<nav class="u-m-b-16">
    <ul class="breadcrumbs">
        <li>Reports</li>
    </ul>
</nav>
<h1 class="typography--display1 u-m-b-16">Reports</h1>

<nav role="navigation">
    <ul class="menu menu--simple">
        <li>
            <a routerLink="school-preferences" ng-reflect-router-link="school-preferences" href="/reports/school-preferences">School Preferences</a>
        </li>
        <!--<li>
            <a routerLink="daily-audit">Daily Audit</a>
        </li>
        <li>
            <a routerLink=">rental-exclusivity">Rental Exclusivity</a>
        </li>-->
    </ul>
</nav>
